import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WhitespaceValidator } from 'osn-shared';
import { DialogComponent } from '../dialog/dialog.component';
import { ContentGroupDetailDialogDataViewModel } from './content-group-detail-dialog-data.view-model';
import { ContentGroupDetailDialogModalViewModel, ContentGroupDetailDialogVariant } from './content-group-detail-dialog-modal.view-model';

@Component({
  selector: 'osn-cxb-page-detail-dialog',
  templateUrl: './content-group-detail-dialog.component.html',
  styleUrls: ['./content-group-detail-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentGroupDetailDialogComponent implements OnInit {
  @ViewChild(DialogComponent) private readonly dialog: DialogComponent;
  public form: UntypedFormGroup;
  public ContentGroupDetailDialogVariant = ContentGroupDetailDialogVariant;

  public get nameCtrl() {
    return this.form.get('name');
  }

  public get nameCtrlHasError() {
    return this.nameCtrl?.touched && (this.nameCtrl?.hasError('required') || this.nameCtrl?.hasError('whitespace'));
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ContentGroupDetailDialogModalViewModel,
    private readonly formBuilder: UntypedFormBuilder
  ) {}

  public ngOnInit() {
    this.form = this.formBuilder.group({
      name: [this.data?.data?.name || '', [Validators.required, WhitespaceValidator.noWhitespace]],
      description: [this.data.data.description || ''],
    });
  }

  public onCancelClick(): void {
    this.closeDialog();
  }

  public onSaveClick(): void {
    this.validateFormAndClose();
  }

  public onCreateClick(): void {
    this.validateFormAndClose();
  }

  private validateFormAndClose(): void {
    this.form.updateValueAndValidity();
    if (this.form.invalid) {
      return;
    }
    this.closeDialog({
      name: this.form.value.name.trim(),
      description: this.form.value.description.trim(),
    });
  }

  private closeDialog(result?: ContentGroupDetailDialogDataViewModel): void {
    this.dialog.closeDialog(result);
  }
}
